import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import useSmoothScroll from "@/hooks/useSmoothScroll";
import { DemoModalProvider } from "@/components/DemoModalContext";
import { DetailModalProvider } from "@/components/DetailModalContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import DemoModal from "@/components/DemoModal";
import DetailModal from "@/components/DetailModal";
import WhatsAppFab from "@/components/WhatsAppFab";
import TechBackground from "@/components/TechBackground";
import Home from "@/pages/Home";
import BlogPost from "@/pages/BlogPost";

function RouteScroll() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const scrollToHash = () => {
        const el = document.querySelector(hash);
        if (el) {
          if (window.__lenis) window.__lenis.scrollTo(el, { offset: -90 });
          else el.scrollIntoView({ behavior: "smooth" });
        }
      };
      const t = setTimeout(scrollToHash, 250);
      return () => clearTimeout(t);
    }
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
}

function Layout() {
  useSmoothScroll();
  return (
    <div className="relative min-h-screen">
      <TechBackground />
      <RouteScroll />
      <Navbar />
      <DemoModal />
      <DetailModal />
      <WhatsAppFab />
      <div className="relative z-10">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
        </Routes>
        <Footer />
      </div>
    </div>
  );
}

function App() {
  return (
    <DemoModalProvider>
      <DetailModalProvider>
        <BrowserRouter>
          <Layout />
        </BrowserRouter>
      </DetailModalProvider>
      <Toaster
        position="top-center"
        richColors
        toastOptions={{ style: { fontFamily: "Plus Jakarta Sans, sans-serif" } }}
      />
    </DemoModalProvider>
  );
}

export default App;
